export enum StateEnum {
    Wyoming = 65
}